import { Transform } from 'class-transformer';
import { isNil } from '@worksolutions/utils';

function getValue(targetValue, defaultValue) {
    return isNil(targetValue) ? defaultValue : targetValue;
}
function withDefaultValue(defaultValue) {
    return Transform((target)=>getValue(target.value, defaultValue));
}
function withDefaultValueFunc(getDefaultValue) {
    return Transform((target)=>getValue(target.value, getDefaultValue()));
}

export { withDefaultValueFunc as a, withDefaultValue as w };
//# sourceMappingURL=withDefaultValue_chunkExport-VWXBKpG9.mjs.map
